import React from 'react';
import Reveal from './Reveal';

// En-tête commun des pages intérieures : photo pleine largeur, sur-titre, titre, sous-titre.
const PageHeader = ({ image, eyebrow, title, subtitle }) => (
  <section className="page-hero" style={{ backgroundImage: `url(${image})` }}>
    <Reveal as="div" className="container">
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </Reveal>
  </section>
);

export default PageHeader;
